import { BRAND } from "@/config/brand";
import { TESTIDS } from "@/constants/testIds";

// Build gallery using ONLY real Vasquez jobsite photos.
// Assign varied bento sizing for a natural editorial layout.
const SIZE_MAP = [
  "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto", // 1: feature large
  "aspect-[4/3]",
  "aspect-[4/3]",
  "md:col-span-2 aspect-[16/10]", // 4: wide
  "aspect-[4/3]",
  "aspect-[4/3]",
  "md:col-span-2 aspect-[16/10]", // 7: wide
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "md:col-span-2 aspect-[16/10]", // 11: wide
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "md:col-span-2 aspect-[16/10]", // 15: wide
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto", // 19: feature large
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
];

const ITEMS = BRAND.jobPhotos.map((p, i) => ({
  ...p,
  src: p.url,
  span: SIZE_MAP[i] || "aspect-[4/3]",
}));

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid={TESTIDS.gallery.root}
      className="relative bg-[#0a0a0b] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="mb-14 md:mb-20 grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[color:var(--vs-blue)]" />
              <span className="font-mono-accent text-xs tracking-[0.3em] uppercase text-[color:var(--vs-blue)]">
                002 / Completed Work
              </span>
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl font-bold leading-[0.95] tracking-tight">
              Real work.
              <br />
              <span className="chrome-text">Real homes.</span>
              <br />
              <span className="text-[color:var(--vs-blue)]">Real crews.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-gray-400 text-base leading-relaxed">
            A selection of recent projects across Long Island — every photo is
            our own crew, on our own jobsite. No stock imagery.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[minmax(200px,auto)] [grid-auto-flow:dense]">
          {ITEMS.map((it, i) => (
            <div
              key={i}
              data-testid={`${TESTIDS.gallery.item}-${i}`}
              className={`group relative overflow-hidden bg-black border border-white/5 ${it.span}`}
            >
              <img
                src={it.src}
                alt={`${it.label} — ${it.category} · ${it.location}`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/25 to-transparent" />
              <div className="absolute top-4 left-4">
                <span className="inline-block px-2.5 py-1 bg-black/70 backdrop-blur-sm border border-[color:var(--vs-blue)]/60 font-mono-accent text-[10px] tracking-[0.25em] uppercase text-[color:var(--vs-blue)]">
                  {it.category}
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 p-5 flex flex-col gap-1">
                <span className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/70">
                  {it.location}
                </span>
                <span className="font-display uppercase text-lg md:text-xl text-white font-semibold tracking-tight">
                  {it.label}
                </span>
              </div>
              <div className="absolute inset-0 border-0 group-hover:border-2 group-hover:border-[color:var(--vs-blue)] transition-all pointer-events-none" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
